import { render, staticRenderFns } from "./year_zodiac.vue?vue&type=template&id=3bc5640c&"
import script from "./year_zodiac.vue?vue&type=script&lang=js&"
export * from "./year_zodiac.vue?vue&type=script&lang=js&"
import style0 from "./year_zodiac.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports